require('./validation');
require('./delete');
require('./phone');
require('./users/user');
require('./applications/application');
require('./password');
